import { RootState } from 'store';

const CalendarUserState = (state: RootState) => state.dashboard.calendar.users;

export const selectAll = (state: RootState) => CalendarUserState(state).rows;
export const selectLoading = (state: RootState) => CalendarUserState(state).loading;
export const selectHasLoaded = (state: RootState) => CalendarUserState(state).hasLoaded;
export const selectFilterOptions = (state: RootState) => CalendarUserState(state).filterOptions;
export const selectErrorResponse = (state: RootState) => CalendarUserState(state).error;
